import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Mainmenu from '../../Shared/Mainmenu/Mainmenu';
import Projects from '../Projects/Projects';

const Portfolio = () => {
    return (
        <>
            <Mainmenu/>
            <Projects/>
            <Footer/>
        </>
    );
};

export default Portfolio;